import { RegisteredFilterProps } from '../constant/constant';
import CustomDatePicker from './CustomDatePicker';
import Select, { components, DropdownIndicatorProps } from 'react-select';
import { DownCaretIcon } from '../assets/svgImages';
import {
  BulkEmailDetailSelectProps,
  FiltersState,
} from '../interface/interface';

const PatientInvited = (props: BulkEmailDetailSelectProps) => {
  const DropdownIndicator = (props: DropdownIndicatorProps<true>) => {
    return (
      <components.DropdownIndicator {...props}>
        <DownCaretIcon />
      </components.DropdownIndicator>
    );
  };

  return (
    <div className="flex h-10 items-center">
      <label className="flex items-center space-x-3">
        <input
          type="checkbox"
          name="invited"
          id="invited"
          className={`form-checkbox h-5 w-5 text-primary-blue-500 mt-1 cursor-pointer `}
          checked={props.filters?.isInvited}
          onChange={() =>
            props.setFilters((prev: FiltersState | undefined) => ({
              ...prev!,
              isInvited: !prev?.isInvited,
              invitedRegisteredFilter: { label: '', value: '' },
              invitedSelectedRegisteredDate: undefined,
              invitedBetweenDate: undefined,
            }))
          }
        />
        <span className={`text-md text-primary-blue-500 cursor-pointer`}>
          isInvited
        </span>
      </label>
      {props.filters?.isInvited && (
        <div className="flex ms-12">
          <div className="me-5">
            <label className="text-lg font-semibold text-secondary-pink-700">
              Filter By <span className="text-red-500">*</span>
            </label>
            <Select
              className="w-72 cursor-pointer"
              value={
                props.filters?.invitedRegisteredFilter?.value
                  ? (props.filters?.invitedRegisteredFilter as any)
                  : undefined
              }
              options={RegisteredFilterProps as any}
              onChange={(selected: any) => {
                props.setFilters((prev: FiltersState | undefined) => ({
                  ...prev!,
                  invitedRegisteredFilter: selected,
                }));
              }}
              components={{
                DropdownIndicator,
                IndicatorSeparator: () => null,
              }}
            />
          </div>
          <div className="flex">
            <div>
              <label className="text-lg font-semibold text-secondary-pink-700">
                {props.filters?.invitedRegisteredFilter?.value === 'BETWEEN'
                  ? 'From'
                  : 'Invited Date'}
                <span className="text-red-500">*</span>
              </label>
              <CustomDatePicker
                value={props.filters?.invitedSelectedRegisteredDate as Date}
                handleDate={(date) => {
                  props.setFilters((prev: FiltersState | undefined) => ({
                    ...prev!,
                    invitedSelectedRegisteredDate: date,
                  }));
                }}
                maxDate={true}
                className="w-72"
              />
            </div>
            {props.filters?.invitedRegisteredFilter?.value === 'BETWEEN' ? (
              <div className="ms-5">
                <label className="text-lg font-semibold text-secondary-pink-700">
                  To <span className="text-red-500">*</span>
                </label>
                <CustomDatePicker
                  value={props.filters?.invitedBetweenDate as Date}
                  handleDate={(date) => {
                    props.setFilters((prev: FiltersState | undefined) => ({
                      ...prev!,
                      invitedBetweenDate: date,
                    }));
                  }}
                  maxDate={true}
                  className="w-72"
                />
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default PatientInvited;
